import styled, { css } from "styled-components";
import { transparentize } from "polished";
import { color, typeStyle } from "@m/alchemy-theme";
import { cellPadding } from "../constants";
export const TableCell = styled.td `
  a {
    ${typeStyle("link")};
  }

  ${({ backgroundColor, backgroundOpacity = 0, isHighlighted, ...props }) => isHighlighted &&
    css `
      background-color: ${transparentize(backgroundOpacity, backgroundColor ? backgroundColor : color("highlight")(props))};
    `};

  ${({ disabled }) => (disabled ? "opacity: 0.3;" : "")};
  margin: 0;
  padding: ${({ defaultCellPadding }) => defaultCellPadding || cellPadding};
  position: relative;
  text-align: ${({ textAlign }) => textAlign || "left"};
  vertical-align: middle;
  white-space: ${({ maxWidth, whiteSpace }) => (whiteSpace ? whiteSpace : maxWidth ? "inherit" : "nowrap")};
  ${({ shrink }) => shrink && `width: 1px`};
`;
